import React from 'react';
import styled from 'styled-components';
import { theme } from 'antd';

import EditIcon from '@/comp/common/icons/EditIcon';
import TrashIcon from '@/comp/common/icons/TrashIcon';
import { useStores } from '@/hooks/use-stores';
import { MenuType } from '@/store/PIDEditing/PIDEditStore';
import { observer } from 'mobx-react';
import { EPButton } from '@/components';

const { useToken } = theme;

const SensorActions = observer(() => {
  const { pidEditStore } = useStores();
  const { activeMenu } = pidEditStore;
  const { token } = useToken();

  const handleEdit = () => {
    pidEditStore.showMenu(
      MenuType.DeviceDetails,
      { x: activeMenu.position.x, y: activeMenu.position.y },
      activeMenu.context,
    );
  };

  const handleDelete = () => {
    pidEditStore.showMenu(
      MenuType.DeleteDevice,
      { x: activeMenu.position.x, y: activeMenu.position.y },
      activeMenu.context,
    );
  };

  if (!activeMenu || activeMenu.type !== MenuType.SensorActions) return null;

  return (
    <StyledSensorActions position={activeMenu.position}>
      <EPButton
        color={token.colorPrimaryBg}
        shape="circle"
        icon={<EditIcon color={token.colorPrimary} />}
        onClick={handleEdit}
      />
      <EPButton
        color={token.colorPrimaryBg}
        shape="circle"
        icon={<TrashIcon color={token.colorError} />}
        onClick={handleDelete}
      />
    </StyledSensorActions>
  );
});

const StyledSensorActions = styled.div<{ position: { x: number; y: number } }>`
  position: absolute;
  left: ${props => props.position.x}px;
  top: ${props => props.position.y}px;
  transform: translate(-50%, 50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme: { token } }) => token.padding}px;
  z-index: 3;
`;

export default SensorActions;
